import React from 'react';
import {Box} from '@mui/material';
import Filter from './Filter';
const LandingPage = ()=>{

    return(
        <Box sx={{background:'#181818'}}>
            <Filter/>
        </Box>
    )
}

export default LandingPage
